export default __webpack_public_path__ + "static/media/kku_logo.748d2177.jpg";